// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Hero__container___uHIdu{max-width:inherit;height:660px;margin-top:-64px;padding:0 24px;border-top:64px solid transparent;background-color:#fcf7e8;background-repeat:no-repeat;background-position:100% 100%;background-size:contain}@media (max-width:719px){.Hero__container___uHIdu{background-size:auto 330px}}.Hero__inner___1rgEo{display:flex;min-height:656px;padding-top:88px}@media (max-width:959px){.Hero__inner___1rgEo{min-height:745px;padding-top:32px}}.Hero__subtitle___2GVpP{max-width:650px;margin:0;padding-bottom:53px;color:#564f34;font-size:20px}.Hero__subtitle___2GVpP p{line-height:32px}@media (min-width:1280px){.Hero__subtitle___2GVpP{margin-top:16px}}@media (max-width:959px){.Hero__subtitle___2GVpP{font-size:16px;line-height:24px}}.Hero__title___6gpBH h1{max-width:725px;color:#2c2302;font-weight:500;font-size:52px;line-height:64px}@media (max-width:959px){.Hero__title___6gpBH h1{font-size:28px;line-height:40px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "Hero__container___uHIdu",
	"inner": "Hero__inner___1rgEo",
	"subtitle": "Hero__subtitle___2GVpP",
	"title": "Hero__title___6gpBH"
};
module.exports = ___CSS_LOADER_EXPORT___;
